import { AppContext, type Plugin, createApp, h, reactive } from 'vue'

import { I18N_ADDON_SYMBOL } from '@/i18n/i18n'

import InstreamWrapper from './template/InstreamWrapper.vue'

export type WrapperControls = {
    isVisible: boolean
    isOverlayVisible: boolean
    secondsLeft: number
    onResume: () => void
}

export type Wrapper = {
    controls: WrapperControls
    wrapper: HTMLDivElement
}

export function renderWrapper({ vueAppContext }: { vueAppContext: AppContext | undefined }): Wrapper {
    const wrapper = document.createElement('div')
    wrapper.classList.add('instream-wrapper')
    document.body.insertAdjacentElement('beforeend', wrapper)

    const i18nAddonPluginInstance = vueAppContext?.provides[I18N_ADDON_SYMBOL] as Plugin | undefined

    const controls = reactive({
        isVisible: false,
        isOverlayVisible: false,
        secondsLeft: 0,
        onResume: () => undefined,
    } as WrapperControls)

    if (!i18nAddonPluginInstance) {
        throw new Error(`Cannot create the google instream wrapper app due to error: i18nPlugin is unavailable`)
    }

    try {
        createApp(() => h(InstreamWrapper, controls))
            .use(i18nAddonPluginInstance)
            .mount(wrapper)
        return { controls, wrapper }
    } catch (e) {
        throw new Error(`Cannot create the google instream wrapper app due to error: ${e}`)
    }
}
